import React, { Component } from "react";
import Select from "react-select";
import { withRouter, Link } from "react-router-dom";

import { auth } from "../../utils/auth";
import { apiUrl } from "../../utils/apiUrl";
import { withRequest } from "../../utils/request";
import { formatDate, formatCurrency, getLink } from "../../utils/helpers";
import Loader from "../general/Loader";
import dayjs from "dayjs";
import Modal from "../general/Modal";

class Edit extends Component {
    state = {
        errors: {},
        compra: {},
        contactos: [],
        items: [],
        grupos: [],
        almacenes: [],
        total: 0,
        showEliminar: false,
    };
    componentDidMount() {
        const compra = this.props.match.params.id;

        this.getCompra(compra);
        this.getTable("contactos");
        this.getTable("almacenes");
    }
    getCompra = async (id) => {
        const table = await this.props.request("compras/" + id);

        if (table.data) {
            this.setState({
                compra: table.data,
                loading: false,
            });
        }
    };
    getTable = async (url = null, params = "") => {
        const table = await this.props.request(url + params);

        if (table.data) {
            this.setState({
                [url]: table.data,
                loading: false,
            });
        }
    };
    editCompra = async (event) => {
        event.preventDefault();

        const token = auth.getToken();
        const data = new FormData(event.target);

        const res = await fetch(apiUrl(`compras/${this.state.compra.id}`), {
            method: "post",
            body: data,
            headers: {
                Accept: "application/json",
                "X-Request-With": "XMLHttpRequest",
                Authorization: "Bearer " + token,
            },
        });

        const response = await res.json();

        if (response.success) {
            this.props.history.push(getLink("/compras"));
        }

        if (response.code === 422) {
            this.setState({ errors: response.data.message });
        }
    };
    deleteCompra = async (event, compra) => {
        event.preventDefault();

        const token = auth.getToken();

        const url = `compras/${compra}`;
        const data = new FormData(event.target);

        const res = await fetch(apiUrl(url), {
            method: "post",
            body: data,
            headers: {
                Accept: "application/json",
                "X-Request-With": "XMLHttpRequest",
                Authorization: "Bearer " + token,
            },
        });

        const response = await res.json();

        if (response.success) {
            window.location = getLink("/compras");
            return;
        } else {
            this.setState({ errors: response.data.message });
        }
    };
    toggleEliminar = () => {
        this.setState({
            showEliminar: !this.state.showEliminar,
        });
    };
    render() {
        const {
            errors,
            compra,
            contactos,
            almacenes,
            showEliminar,
        } = this.state;

        let totalItbis = 0;

        return !compra.id ? (
            <Loader />
        ) : (
            <div className='crear-compra'>
                <div className='page-header'>
                    <h1 className='page-title row'>
                        <span className='col'>Editar Compra</span>
                    </h1>
                </div>
                {compra.borrada && (
                    <div className='alert alert-danger p-10'>
                        <i className='fas fa-exclamation-triangle m-r-15'></i>{" "}
                        Esta compra fue borrada.
                    </div>
                )}
                <form
                    method='post'
                    onSubmit={this.editCompra}
                    onKeyUp={this.preventEnter}
                    className='row crear-compra-form'>
                    <div className='form-group col-md-4'>
                        <input type='hidden' name='_method' value='patch' />
                        <label className='label form-control-label'>
                            Suplidor:
                        </label>
                        {contactos.length > 0 && (
                            <Select
                                name='contacto_id'
                                isClearable={true}
                                defaultValue={
                                    compra.contacto && {
                                        value: compra.contacto,
                                        label: compra.contacto,
                                    }
                                }
                                options={contactos.map((contacto) => ({
                                    value: contacto.nombre,
                                    label: contacto.nombre,
                                }))}
                            />
                        )}
                        {errors.contacto_id && (
                            <small className='help-blockParams form-Text'>
                                {errors.contacto_id[0]}
                            </small>
                        )}
                    </div>
                    <div className='form-group col-md-4'>
                        <label className='label form-control-label'>
                            Fecha:
                        </label>
                        <input
                            type='date'
                            className='text-input form-control'
                            id='fecha'
                            name='fecha'
                            defaultValue={
                                compra.fecha ?? formatDate(new Date())
                            }
                        />
                        {errors.fecha && (
                            <small className='help-blockParams form-Text'>
                                {errors.fecha[0]}
                            </small>
                        )}
                    </div>
                    <div className='form-group col-md-4'>
                        <label className='label form-control-label'>
                            Fecha Vencimiento:
                        </label>
                        <input
                            type='date'
                            className='text-input form-control'
                            id='fecha_vencimiento'
                            name='fecha_vencimiento'
                            defaultValue={
                                compra.fechaVencimiento ??
                                dayjs().add(30, "days")
                            }
                        />
                        {errors.fecha_vencimiento && (
                            <small className='help-blockParams form-Text'>
                                {errors.fecha_vencimiento[0]}
                            </small>
                        )}
                    </div>
                    <div className='form-group col-md-4'>
                        <label className='label form-control-label'>
                            No. Factura:
                        </label>
                        <input
                            type='text'
                            className='text-input form-control'
                            id='numero'
                            name='numero'
                            defaultValue={compra.numero}
                        />
                        {errors.numero && (
                            <small className='help-blockParams form-Text'>
                                {errors.numero[0]}
                            </small>
                        )}
                    </div>
                    <div className='form-group col-md-4'>
                        <label className='label form-control-label'>NCF:</label>
                        <input
                            type='text'
                            className='text-input form-control'
                            id='ncf'
                            name='ncf'
                            defaultValue={compra.ncf}
                        />
                        {errors.ncf && (
                            <small className='help-blockParams form-Text'>
                                {errors.ncf[0]}
                            </small>
                        )}
                    </div>
                    {almacenes.length > 0 && (
                        <div className='form-group col-md-2'>
                            <label className='label form-control-label'>
                                Almacén:
                            </label>
                            {almacenes.length > 0 && (
                                <select
                                    name='almacen_id'
                                    className='form-control'
                                    defaultValue={compra.almacenId}>
                                    <option value=''>- Seleccionar -</option>
                                    {almacenes.map((almacen) => (
                                        <option
                                            key={almacen.id}
                                            value={almacen.id}>
                                            {almacen.nombre}
                                        </option>
                                    ))}
                                </select>
                            )}
                            {errors.contacto_id && (
                                <small className='help-blockParams form-Text'>
                                    {errors.almacen_id[0]}
                                </small>
                            )}
                        </div>
                    )}
                    <div className='form-group col-md-2'>
                        <label className='label form-control-label'>
                            Tipo:
                        </label>
                        <select
                            name='tipo'
                            defaultValue={compra.tipo}
                            className='form-control'>
                            <option value='Contado'>Contado</option>
                            <option value='Crédito'>Crédito</option>
                        </select>
                        {errors.tipo && (
                            <small className='help-blockParams form-Text'>
                                {errors.tipo[0]}
                            </small>
                        )}
                    </div>
                    <div className='col-md-12'>
                        <table className='table'>
                            <thead>
                                <tr>
                                    <th width='50px'>No.</th>
                                    <th width='30%'>Item</th>
                                    <th>Cantidad</th>
                                    <th>Costo</th>
                                    <th>Desc.</th>
                                    {compra.itbis > 0 && <th>ITBIS</th>}
                                    <th width='18%'>Grupo</th>
                                    <th className='text-right' width='12%'>
                                        Sub-total
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {compra.items &&
                                    compra.items.map((item, index) => {
                                        const itbis = compra.itbis
                                            ? (parseFloat(item.costo)+.005) / 1.18 * item.cantidad * 0.18
                                            : 0;
                                        totalItbis += itbis;
                                        const costoOrig =
                                            (item.costo /
                                                (100 -
                                                    parseFloat(
                                                        item.descuento
                                                    ))) *
                                            100;
                                        return (
                                            <tr key={item.id}>
                                                <td>{index + 1}.</td>
                                                <td>
                                                    <Link
                                                        to={getLink(
                                                            `/inventario/${item.id}/informacion`
                                                        )}>
                                                        {item.nombre}
                                                    </Link>
                                                </td>
                                                <td>{item.cantidad}</td>
                                                <td>
                                                    {formatCurrency(costoOrig)}
                                                </td>
                                                <td>
                                                    {parseFloat(item.descuento)
                                                        ? item.descuento + "%"
                                                        : 0}
                                                </td>
                                                {compra.itbis > 0 && (
                                                    <td>
                                                        {formatCurrency(itbis)}
                                                    </td>
                                                )}
                                                <td>{item.grupo}</td>
                                                <td className='text-right'>
                                                    {formatCurrency(
                                                        item.costo *
                                                            item.cantidad -
                                                            itbis
                                                    )}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                {compra.itbis > 0 && (
                                    <tr>
                                        <td colSpan='7' className='text-right'>
                                            <strong className='label form-control-label'>
                                                ITBIS:
                                            </strong>
                                        </td>
                                        <td className='text-right'>
                                            {formatCurrency(totalItbis)}
                                        </td>
                                    </tr>
                                )}
                                <tr>
                                    <td
                                        colSpan={compra.itbis ? 7 : 6}
                                        className='text-right'>
                                        <strong className='label form-control-label'>
                                            Total:
                                        </strong>
                                    </td>
                                    <td className='text-right'>
                                        {formatCurrency(
                                            parseFloat(compra.total)
                                        )}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <hr />
                    </div>
                    <div className='form-group col-md-12'>
                        <label className='label form-control-label'>
                            Nota:
                        </label>
                        {compra.borrada ? (
                            <div>{compra.descripcion}</div>
                        ) : (
                            <textarea
                                className='text-input form-control'
                                id='descripcion'
                                name='descripcion'
                                rows='4'
                                defaultValue={compra.descripcion}
                            />
                        )}
                        {errors.descripcion && (
                            <small className='help-blockParams form-Text'>
                                {errors.descripcion[0]}
                            </small>
                        )}
                    </div>
                    <div className='page-footer text-right col-md-12'>
                        {!compra.borrada && (
                            <button
                                type='button'
                                className='btn float-left'
                                onClick={this.toggleEliminar}>
                                <i className='fas fa-trash-alt'></i>
                            </button>
                        )}
                        <button
                            type='button'
                            onClick={() =>
                                (window.location = getLink("/compras"))
                            }
                            className='btn btn-plain'>
                            Cancelar
                        </button>
                        <button type='submit' className='btn btn-primary'>
                            Guardar
                        </button>
                    </div>
                </form>
                <Modal
                    show={showEliminar}
                    blank={true}
                    toggle={this.toggleEliminar}>
                    <form onSubmit={(e) => this.deleteCompra(e, compra.id)}>
                        <div className='popup__header'>Eliminar Compra</div>
                        <div className='popup__body'>
                            <p className='m-b-20'>
                                Esta acción no puede ser revertida. Si deseas
                                continuar por favor indica la razón por la cual
                                deseas eliminarla:
                            </p>
                            <textarea
                                className='form-control'
                                name='descripcion'
                                required
                                rows='5'></textarea>
                        </div>
                        <div className='popup__footer'>
                            <button
                                onClick={this.toggleEliminar}
                                type='button'
                                className='btn btn-plain'>
                                Cancelar
                            </button>
                            <button type='submit' className='btn btn-primary'>
                                Eliminar
                            </button>
                        </div>
                    </form>
                </Modal>
            </div>
        );
    }
}

export default withRouter(withRequest(Edit));
